import React from "react";
import CustomerCheckSerialNumberForm from "./CustomerCheckSerialNumberForm";
import MainPageCompenent from './MainPageCompenent';
function CustomerCheckSerialNumber(props) {
    return (
        <MainPageCompenent>
            <CustomerCheckSerialNumberForm />
        </MainPageCompenent>
    );
}

export default CustomerCheckSerialNumber;